export default __webpack_public_path__ + "static/media/pic2.0e68d9f3.jpg";